import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1f8617f4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "basic-info" }
const _hoisted_2 = { class: "detail-block" }
const _hoisted_3 = { class: "info-head df aic" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "title-block" }, null, -1))
const _hoisted_5 = {
  class: "info-head-title",
  style: {"flex":"1","line-height":"32px"}
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "求职期望", -1))
const _hoisted_7 = /*#__PURE__*/_createTextVNode("编辑")
const _hoisted_8 = {
  key: 0,
  class: "detail-item-block"
}
const _hoisted_9 = {
  key: 1,
  class: "no-explist-info"
}
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" 暂无求职期望")
const _hoisted_11 = /*#__PURE__*/_createTextVNode("立即修改")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_v_preview_item = _resolveComponent("v-preview-item")!
  const _component_v_preview = _resolveComponent("v-preview")!
  const _component_Expect = _resolveComponent("Expect", true)!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _createElementVNode("span", _hoisted_5, [
            _hoisted_6,
            _createVNode(_component_el_button, {
              class: "card-header-btn",
              icon: _ctx.EditPen,
              type: "text",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.edit()))
            }, {
              default: _withCtx(() => [
                _hoisted_7
              ]),
              _: 1
            }, 8, ["icon"])
          ])
        ]),
        (_ctx.detail.forwardPostType && _ctx.detail.forwardPostName)
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
              _createVNode(_component_v_preview, {
                itemTopSpace: "5px",
                "label-width": "130px",
                style: {"margin":"0 auto"}
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_preview_item, {
                    width: "50%",
                    label: "期望职位"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.detail.forwardPostName), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_preview_item, {
                    width: "50%",
                    label: "期望行业"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.detail.forwardPostTypeName), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_preview_item, {
                    width: "50%",
                    label: "薪资要求(元/月)"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.detail.forwardMinSalaryName) + " ~ " + _toDisplayString(_ctx.detail.forwardMaxSalaryName), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_preview_item, {
                    width: "50%",
                    label: "求职类型"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.detail.jobTypeName), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_preview_item, {
                    width: "50%",
                    label: "工作城市"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.detail.forwardLocation), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_9, [
              _hoisted_10,
              _createVNode(_component_el_button, {
                type: "text",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.edit()))
              }, {
                default: _withCtx(() => [
                  _hoisted_11
                ]),
                _: 1
              })
            ]))
      ])
    ]),
    _createVNode(_component_el_dialog, {
      modelValue: _ctx.dialogVisible,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.dialogVisible) = $event)),
      title: "编辑求职期望",
      width: "880px",
      "destroy-on-close": true
    }, {
      default: _withCtx(() => [
        _createVNode(_component_Expect, {
          isDialog: true,
          closeDialog: _ctx.closeDialog,
          successCallBack: _ctx.save,
          expectForm: _ctx.expectForm
        }, null, 8, ["closeDialog", "successCallBack", "expectForm"])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}